export default "__VITE_PUBLIC_ASSET__56b4ec68__"